import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../i18n/translate.js';
import PasswordInput from '../../components/Input/PasswordInput.js';
import Image from '../../components/Image/Image.js';
import styles from './PinCode.module.scss.js';
import img from './users_pin.png.js';
import { PinCodeLabelUtil } from './usePinCodeUtility.js';

var PinCode = function PinCode(_ref) {
  var isPolling = _ref.isPolling,
    pinCodeLength = _ref.pinCodeLength,
    code = _ref.code,
    validateInput = _ref.validateInput,
    isValidCode = _ref.isValidCode,
    displayText = _ref.displayText,
    secondaryDisplayText = _ref.secondaryDisplayText,
    inputMode = _ref.inputMode;
  var _PinCodeLabelUtil = PinCodeLabelUtil(pinCodeLength),
    info = _PinCodeLabelUtil.info,
    placeholder = _PinCodeLabelUtil.placeholder;
  return /*#__PURE__*/React.createElement("section", {
    className: styles.startStep
  }, /*#__PURE__*/React.createElement(Image, {
    url: img,
    className: styles.img
  }), info && info.map(function (label) {
    return /*#__PURE__*/React.createElement("p", {
      key: label,
      className: styles.text
    }, t(label));
  }), /*#__PURE__*/React.createElement(PasswordInput, {
    maxLength: pinCodeLength,
    onChange: validateInput,
    placeholder: t(placeholder),
    value: code,
    dataTestId: "codeInput",
    hasError: Boolean(code && !isValidCode),
    errorMessage: null,
    disabled: isPolling,
    autoComplete: "off",
    disableAutofill: true,
    className: styles.userInputField,
    inputMode: inputMode
  }), displayText && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    id: "pinCodeDisplayText",
    className: styles.error
  }, displayText), secondaryDisplayText && /*#__PURE__*/React.createElement("p", {
    id: "secondaryPinCodeDisplayText",
    className: styles.secondaryError
  }, secondaryDisplayText)));
};
PinCode.propTypes = {
  isPolling: PropTypes.bool.isRequired,
  pinCodeLength: PropTypes.number.isRequired,
  code: PropTypes.string.isRequired,
  validateInput: PropTypes.func.isRequired,
  isValidCode: PropTypes.bool.isRequired,
  displayText: PropTypes.string.isRequired,
  secondaryDisplayText: PropTypes.string,
  inputMode: PropTypes.string
};
PinCode.defaultProps = {
  inputMode: 'numeric',
  secondaryDisplayText: ''
};

export { PinCode as default };
